import React from 'react';
import { ModeProps } from '../../types';
import { Shield, Lock, FileCheck, Server } from 'lucide-react';
export function TrustSection({
  mode
}: ModeProps) {
  const isBusiness = mode === 'business';
  return <section className="py-24 bg-slate-50 border-y border-slate-200" data-id="element-728">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-729">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-730">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-731">
            {isBusiness ? 'Compliance-first Infrastructure' : 'Safe, Secure, Regulated'}
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-732">
            {isBusiness ? 'Built on a foundation of regulatory compliance, bank-grade security, and rigorous audits. We simplify global stablecoin infrastructure and security — so you can focus on building.' : 'Your money is protected by regulated partners and institutional-grade security.'}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-733">
          <div className="flex flex-col items-center text-center" data-id="element-734">
            <Shield className="w-10 h-10 text-slate-900 mb-4" data-id="element-735" />
            <h3 className="font-semibold text-slate-900 mb-2" data-id="element-736">Regulated</h3>
            <p className="text-sm text-slate-600" data-id="element-737">
              Fully compliant with global financial regulations.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-738">
            <Lock className="w-10 h-10 text-slate-900 mb-4" data-id="element-739" />
            <h3 className="font-semibold text-slate-900 mb-2" data-id="element-740">
              Secure Custody
            </h3>
            <p className="text-sm text-slate-600" data-id="element-741">
              Assets held in segregated, audited accounts.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-742">
            <FileCheck className="w-10 h-10 text-slate-900 mb-4" data-id="element-743" />
            <h3 className="font-semibold text-slate-900 mb-2" data-id="element-744">Audited</h3>
            <p className="text-sm text-slate-600" data-id="element-745">
              Regular third-party security and financial audits.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-746">
            <Server className="w-10 h-10 text-slate-900 mb-4" data-id="element-747" />
            <h3 className="font-semibold text-slate-900 mb-2" data-id="element-748">Reliable</h3>
            <p className="text-sm text-slate-600" data-id="element-749">
              99.99% uptime SLA for critical infrastructure.
            </p>
          </div>
        </div>
      </div>
    </section>;
}